import { get as _get } from 'lodash';
import React from 'react';
import Loader from 'react-loader-advanced';
import { connect } from 'react-redux';
import { reduxStateMap, withReducerName } from '../redux/reduxMap';

export default connect((state) => ({
    isLoading: _get(state, withReducerName(reduxStateMap.IS_LOADING))
}))(function LoadingIndicator({ isLoading }) {
    if (!isLoading) {
        return <></>;
    }
    return (
        <Loader
            message={
                <div className="loading-indicator">
                    <div className="loader" />
                </div>
            }
            show={isLoading}
            style={{ display: isLoading ? 'block' : 'none', position: 'absolute' }}
        />
    );
});
